import {FeatureName} from '@hproduce/suite-core'

export const isHierarchyIndependentFeature = (featureName: FeatureName): boolean =>
  featureName === 'RcfaCompliance' ||
  featureName === 'ExpertSystemUsageRate' ||
  featureName === 'Tasks'
